module.exports = __webpack_public_path__ + "img/product-placeholder-62.d64556c.png";